import React from 'react'

// Shared class for clickable badges
const CLICKABLE_BADGE_CLASS = 'cursor-pointer hover:opacity-80'

// Reusable wrapper for clickable badges
export const ClickableBadgeWrapper = ({
  onClick,
  children,
}: {
  onClick?: (e: React.MouseEvent) => void
  children: React.ReactNode
}) => {
  const className = onClick ? CLICKABLE_BADGE_CLASS : ''

  return (
    <div className={className} onClick={onClick}>
      {children}
    </div>
  )
}
